import type { AgentExecutionLight } from "@stockline/shared/types/ai/execution"
import { EXECUTION_TABLE } from "../../../lib/offline/resources/ai/execution/db"
import { useAISync } from "../providers/AISyncProvider"

export function useExecution(id: string): AgentExecutionLight | null {
  const { reactive } = useAISync()
  return reactive.useOne<AgentExecutionLight>(EXECUTION_TABLE, id)
}
